import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = () => ({
  root: {},
  rootHidden: {
    display: 'none',
  },
});

const TitleText = ({
  className,
  classes,
  title,
}) => {
  return (
    <Typography
      className={
        classNames(classes.root, className, {
          [classes.rootHidden]: !title,
        })
      }
      variant={'h4'}
      color={'white'}
      weight={'bold'}
    >
      {title}
    </Typography>
  );
};

TitleText.defaultProps = {
  className: '',
  title: null,
};

TitleText.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
};

export default withStyles(styles)(TitleText);
